<div class="map">
  <div class="map__outlet"
       #mapOutlet
  ></div>
</div>
